import { z } from 'zod';
import type { GetCardDto } from '../types/GetCardDto';

export const getCardDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(3).max(255),
  type: z.enum(['video', 'image', 'text', 'textAndImage', 'quiz', 'redirect']),
  content: z.string().nullable(),
  contentImage: z.string().nullable(),
  contentDetails: z.string().nullable(),
  position: z.number().int().min(1),
  isActive: z.boolean().default(false).optional(),
}) as z.ZodType<GetCardDto>;
